import { render, staticRenderFns } from "./CoursewareFeedbackPopup.vue?vue&type=template&id=2780a788&scoped=true&"
import script from "./CoursewareFeedbackPopup.vue?vue&type=script&lang=js&"
export * from "./CoursewareFeedbackPopup.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareFeedbackPopup.vue?vue&type=style&index=0&id=2780a788&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2780a788",
  null
  
)

export default component.exports